/**
 * This component renders the sidebar for news articles
 * WARNING - Currently using some dummy data
 */
import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ThreeDots } from "react-loader-spinner";
import NewsSideSingle from "./SingleNews.js";
import { useState, useEffect } from "react";
import GameSidebar from "../game/GameSidebar";

const SidebarContent = (game_data) => {
  const { newsId } = useParams();

  const [data, setData] = useState(undefined);

  // Fetch player data from API
  useEffect(() => {
    setData(undefined);

    fetch(`${process.env.REACT_APP_BUIHA_API_URL}/news/sidebar`)
      .then((response) => response.json())
      .then((json) => {
        let data = json;

        setData(data);
      })
      .catch((error) => console.error(error));
  }, [newsId]);

  game_data = game_data.game_data;

  return data ? (
    <>
      <div className="sidebar w-full flex flex-col items-center justify-start w-auto xs:m-1 xs:mx-4 pt-4 xs:mb-4 xl:mr-8 xl:px-0 px-2 xxs:px-4">
        <div className="max-w-[800px] w-full">

          {game_data ? <GameSidebar game_data={game_data} headless={true}/> : <></>}

          <div className="flex flex-col mb-1 justify-center items-center">
            <h2 className="text-xl font-normal text-center">Recent News</h2>

            <div className="w-full h-2 my-2 bg-gradient-to-r from-blue-600 via-purple-600 to-red-600">
              <p className="hidden">Gradient line</p>
            </div>
          </div>

          <div className="max-xl:max-w-[400px] flex flex-col w-full items-start justify-start mx-auto">
            {data.map((article) => {
              if (article.id != newsId) {
                return (
                  <div
                    key={article.id}
                    className="w-full flex flex-col justify-start items-center"
                  >
                    <NewsSideSingle
                      id={article.id}
                      title={article.title}
                      author={article.author_name}
                      img={article.img}
                      mdcontent={article.mdcontent}
                      url_override={article.url}
                    />
                  </div>
                );
              }
              return null;
            })}
          </div>
        </div>
      </div>
    </>
  ) : (
    // three dots loader
    <div className="flex justify-center items-center h-96">
      <ThreeDots color="#FFF" height={96} width={96} />
    </div>
  );
};

export default SidebarContent;
